import { JsonSerializable } from '../shared/jsonSerializable';
import { ThirdParty } from '../entity/third-party';
import * as moment from 'moment/moment';

export class SubscriptionModel extends JsonSerializable {

  code: string;
  title: string;
  subtitle: string;
  description: string;
  duration: string;
  resultDelay: string;
  collectDetail: string;
  parameters: string[];
  category: string;
  pricing: string;
  frequency: string;
  
  count: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
  isNotifyIdentification: boolean;
  isSendKit: boolean;
  sendKitDelay: number;
  isRenewal: boolean;
  isNotifyLaboratory: boolean;
  notifyLaboratoryDelay: number;
  samplesNumber: number;
  parentSubscription: SubscriptionModel;
  thirdPartyApplicant: ThirdParty;
  thirdPartyOwner: ThirdParty;


  constructor() {
    super();
    this.code = null;
    this.title = null;
    this.subtitle = null;
    this.description = null;
    this.resultDelay = null;
    this.collectDetail = null;
    this.parameters = new Array();
    this.category = null;
    this.pricing = null;
    this.frequency = null;

    this.count = null;
    this.duration = null;
    this.startDate = null;
    this.endDate = null;
    this.isNotifyIdentification = null;
    this.isSendKit = null;
    this.sendKitDelay = null;
    this.isRenewal = null;
    this.isNotifyLaboratory = null;
    this.notifyLaboratoryDelay = null;
    this.samplesNumber = null;
    this.parentSubscription = null;
    this.thirdPartyApplicant = null;
    this.thirdPartyOwner = null;
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {        
        if(jsonObj[propName] instanceof Object){
          if (propName == "parentSubscription") {
            this[propName] = new SubscriptionModel();
          } else if (propName == "thirdPartyApplicant") {
            this[propName] = new ThirdParty();
          } else if (propName == "thirdPartyOwner") {
            this[propName] = new ThirdParty();
          }
          this[propName].fromJSON(jsonObj[propName]);
        } else {
          this[propName] = jsonObj[propName];
        }
      } else {
        
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/entity/subscription-model.ts